<template>
  <v-dialog v-model="modal" width="800" scrollable>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{ menu === 'petunjuk' ? 'Petunjuk' : 'Daftar Anggota Terpilih' }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon depressed @click="modal = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text class="py-5 px-1 black--text">
        <template v-if="menu === 'petunjuk'">
          <v-tabs vertical class="px-0 black--text">
            <v-tab class="text-capitalize"> 1x Tayang </v-tab>
            <v-tab class="text-capitalize"> Harian </v-tab>
            <v-tab class="text-capitalize"> Mingguan </v-tab>
            <v-tab class="text-capitalize"> Bulanan </v-tab>

            <v-tab-item v-for="(item, i) in MPETUJUK" :key="i" class="px-5">
              <v-card flat>
                <v-card-text class="black--text">
                  <div class="text-h6 font-weight-regular">{{ item.label }}</div>
                  <div>
                    <span v-html="item.desc" />
                  </div>
                  <div class="text-h6 mt-3 font-weight-regular primary--text"> Contoh Kasus </div>
                  <span class="font-weight-bold text-h5">"</span><span class="font-italic" v-html="item.example" /><span
                    class="font-weight-bold text-h5"
                    >"</span
                  >
                  <div class="text-h6 mt-3 font-weight-regular primary--text">
                    Bagaimana Mengelola Waktu Kuisioner ??
                  </div>
                  <div class="font-italic"> <span v-html="item.waktu" /> </div>
                  <v-img :src="item.img" />
                  <div class="text-h6 mt-3 font-weight-regular primary--text"> Gambaran Masa Berlaku Kuesioner </div>
                  <v-img :src="item.imgExample" />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </template>
        <template v-else>
          <div class="px-5">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <td></td>
                    <td>Nama Anggota</td>
                    <td>Peran</td>
                    <td>Group</td>
                    <td>Status Pengguna</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in userList" :key="i">
                    <td>
                      <v-checkbox :inputValue="1" :trueValue="1" :value="1" @click="onDeleteUser(item)"></v-checkbox>
                    </td>
                    <td>
                      <v-row wrap class="pt-3">
                        <v-col cols="2" align="center" justify="center">
                          <v-avatar :size="40" color="grey lighten-4">
                            <v-img
                              :src="
                                item.file_foto ? item.file_foto : item.gender == 'P' ? 'img/cewek.png' : 'img/cowok.png'
                              "
                              alt="avatar"
                            />
                          </v-avatar>
                        </v-col>
                        <v-col cols="10" class="mt-1 pt-1">
                          <p class="subtitle font-weight-bold my-0 py-0">
                            <router-link
                              class="ok"
                              :to="{
                                name: 'user.detail',
                                params: {
                                  organisasi_id: organisasi_id,
                                  user_id: item.user_id,
                                },
                              }"
                              >{{ item.nama | toTitleCase }}</router-link
                            >
                          </p>
                          <p class="grey--text caption">
                            {{ pVal(item, 'email') }} <br />
                            {{ (item && item.no_pegawai) || 'Belum tersedia nomor pegawai' }}
                          </p>
                        </v-col>
                      </v-row>
                    </td>
                    <td>{{ pVal(item, 'role') }}</td>
                    <td>
                      <template v-if="item.groups_member && item.groups_member.length">
                        <div v-for="(grup, g) in item.groups_member" :key="g">
                          {{ getDeepObj(grup, 'groups.nama') }}
                        </div>
                      </template>
                      <template v-else> - </template>
                    </td>
                    <td>
                      <v-chip small outlined :color="item.is_aktif == 1 ? 'info' : 'red'">{{
                        item.is_aktif == 1 ? 'Aktif' : 'Tidak Aktif'
                      }}</v-chip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { M_PETUNJUK } from '@/modules/kuesioner/const'
export default {
  props: {
    users: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modal: false,
      menu: 'petunjuk',
      kTipe: 1,
      selected: [],
      MPETUJUK: M_PETUNJUK,
      timelineItems: [
        {
          title: 'Event 1',
          subtitle: 'June 1, 2023',
          content: 'Lorem ipsum dolor sit amet.',
          icon: 'mdi-calendar',
          color: 'indigo',
          class: 'align-start', // Custom CSS class to align the item to the start
        },
        // Add more timeline items here...
      ],
    }
  },
  computed: {
    userList() {
      let selected = []
      Object.keys(this.selected).forEach((item) => {
        if (this.selected[item] || this.selected[item] === 1) {
          selected.push(Number(item))
        }
      })

      return this.users.filter((item) => selected.includes(Number(item.user_id))) || []
    },
  },
  methods: {
    open(obj, menu) {
      this.menu = menu
      this.$set(this, 'kTipe', Number(this.getDeepObj(obj, 'k_tipe_pengisian')))
      this.$set(this, 'selected', (obj && obj.selected) || [])
      this.modal = true
    },

    onDeleteUser(item) {
      this.$delete(this.selected, item.user_id)
      this.$emit('delete', item)
    },
  },
}
</script>
